/**
 * Load the Spotify Web Playback SDK once. No npm package — script from scdn.co.
 */
export function loadSpotifySdk(): Promise<void> {
  if (window.Spotify?.Player) return Promise.resolve();

  return new Promise((resolve, reject) => {
    const timeout = window.setTimeout(
      () => reject(new Error("Spotify player SDK did not load")),
      15_000,
    );

    const prev = window.onSpotifyWebPlaybackSDKReady;
    window.onSpotifyWebPlaybackSDKReady = () => {
      window.clearTimeout(timeout);
      prev?.();
      resolve();
    };

    if (!document.getElementById("spotify-player-sdk")) {
      const script = document.createElement("script");
      script.id = "spotify-player-sdk";
      script.src = "https://sdk.scdn.co/spotify-player.js";
      script.async = true;
      script.onerror = () => {
        window.clearTimeout(timeout);
        reject(new Error("Could not load Spotify player SDK"));
      };
      document.head.appendChild(script);
    }
  });
}
